import { render, staticRenderFns } from "./assign-solo.vue?vue&type=template&id=4bfe59de&scoped=true&"
import script from "./assign-solo.vue?vue&type=script&lang=js&"
export * from "./assign-solo.vue?vue&type=script&lang=js&"
import style0 from "./assign-solo.vue?vue&type=style&index=0&id=4bfe59de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfe59de",
  null
  
)

export default component.exports